import { createFileRoute, useParams } from "@tanstack/react-router";

import { AcknowledgementReadConfirmPage } from "@/components/pages/AcknowledgementReadConfirmPage";

export const Route = createFileRoute(
  "/_authenticated/acknowledgements/$requestId",
)({
  component: AcknowledgementReadConfirmRoute,
});

function AcknowledgementReadConfirmRoute() {
  const { requestId } = useParams({
    from: "/_authenticated/acknowledgements/$requestId",
  });
  return <AcknowledgementReadConfirmPage requestId={requestId} />;
}
